<script lang="ts" setup>
import { OcticonButton } from '@sancare/typescript-commons'
import { ref } from 'vue'

import { CodedRehabilitationAct } from '@/store/modules/stay/smr/types'


defineProps<{
  codedRehabilitationAct: CodedRehabilitationAct
}>()

const isLoading = ref(false)

async function removeAct() {
  // TODO: https://app.clickup.com/t/2628858/WEB-2244
}
</script>

<template>
  <div class="row align-items-center g-0 hoverable-item flex-nowrap">
    <div
      v-tooltip="codedRehabilitationAct.associatedAct.description || null"
      class="col-11 col-lg-10 me-auto"
    >
      <div
        :id="codedRehabilitationAct.associatedAct.reference +'-rehabilitation-act'"
        class="rehabilitation-act-ref"
      >
        <strong>
          {{ codedRehabilitationAct.associatedAct.reference }}
        </strong>
      </div>
      <div
        v-if="codedRehabilitationAct.associatedAct.description"
        class="rehabilitation-act-description"
      >
        {{ codedRehabilitationAct.associatedAct.description }}
      </div>
    </div>
    <div class="col-auto">
      <!-- <v-dropdown>
        TODO: https://app.clickup.com/t/2628858/WEB-2245 -->
      <octicon-button
        v-tooltip="$t('comingSoon')"
        class="rehabilitation-act-delete-btn"
        :is-loading="isLoading"
        octicon-name="trash"
        :width="15"
        title="Supprimer l'acte"
        :is-disabled="true"
      />
      <!--
        <template #popper>
          <h4 class="title-light text-center">
            Êtes-vous sûr(e) ?
          </h4>
          <div class="text-center">
            <button
              class="btn btn-danger btn-padded"
              @click="removeAct()"
            >
              Confirmer
            </button>
          </div>
        </template>
        -->
      <!-- </v-dropdown> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rehabilitation-act-description {
  font-size: .85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
